import React from "react";
import "../styles/whyus.css"; // ✅ reuse styles
import pizzaIcon from "../assets/pizza-icon.svg";

const ORDER_URL = "https://debrecenipizza.hu/";

export default function BulkOrder() {
  return (
    <section className="whyus-section py-5">
      <div className="container">
        <div className="row align-items-center p-4 p-lg-0">
          {/* Left: Content */}
          <div className="col-lg-6 order-2 order-lg-1">
            <div className="whyus-content">
              <h2 className="text-center lg-text-start">
                Pizza Debrecenben házhozszállítással akár{" "}
                <span className="highlight">nagyobb mennyiségben?</span>
              </h2>

              <p>
                Ha nagyobb társaságnak vagy céges rendezvényre keresel pizzát
                Debrecenben, a Pizza Home biztos választás. Legyen szó irodai
                ebédről, csapatépítőről vagy hétvégi pizzázásról a barátokkal,
                nálunk a nagyobb rendelés sem jelent problémát.
              </p>

              <ul className="whyus-list">
                <li>
                  <img src={pizzaIcon} alt="" className="icon" />
                  Megnövelt kapacitású konyhánknak köszönhetően gyorsan és
                  pontosan teljesítjük a rendeléseket. Ha 20 db-ot meghaladó
                  pizza rendelést adnál le Debrecenben, kérjük, jelezd legalább
                  2 munkanappal előre, hogy minden gördülékenyen menjen.
                </li>
                <li>
                  <img src={pizzaIcon} alt="" className="icon" />
                  Ha szereted a pizzánkat, és szívesen lennél viszonteladónk,
                  keress minket bizalommal – együtt kitaláljuk, hogyan
                  kínálhatsz Pizza Home-os szeleteket saját vendégeidnek
                  Debrecenben.
                </li>
              </ul>

              <div className="whyus-cta" style={{ textAlign: "center" }}>
                <a href={ORDER_URL} className="btn-order">
                  Hamarosan &gt;&gt;
                </a>
              </div>
            </div>
          </div>

          {/* Right: Image */}
          <div className="col-lg-6 order-1 order-lg-2">
            <div className="whyus-image-wrap pb-5 pb-lg-0">
              <img
                src="/images/Betyar.webp"
                alt="Betyár pizza"
                className="whyus-image"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
